var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapConsumer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var features = ref.features;
return [_c('g',[_vm._t("default",_vm._l((features),function(feature,index){return _c('MapFeature',{key:feature[_vm.idKey] || index,attrs:{"data":feature,"fill":_vm.fill,"stroke":_vm.stroke}})}),{"features":features})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }